module.exports = __webpack_public_path__ + "img/BA.5088ba3f.svg";